import useLocalizedRoutes from "hooks/useLocalizedRoutes";
import React from "react";
import { useTranslation } from "react-i18next";
import { HashLink } from "react-router-hash-link";
import { ReactComponent as Logo } from "../../assets/images/iparque-horizontal-colored.svg";
import { LogoContainer } from "./styles";

const MinimalHeader: React.FC = () => {
  const { t } = useTranslation();
  const { getLanguageRoute } = useLocalizedRoutes();
  const redirectLink = getLanguageRoute("home") as string;

  return (
    <LogoContainer>
      <HashLink to={redirectLink} aria-label={t("653") /* Início */}>
        <Logo
          width="150px"
          role="img"
          title={t("10661") /* Logo da solução de gestão de estacionamento */}
        />
      </HashLink>
    </LogoContainer>
  );
};

export default MinimalHeader;
